import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom'; // <-- 1. Import useNavigate
import './TestingCompaing.css'; 

const TestingCompaing = () => {
    const { t } = useTranslation();
    const navigate = useNavigate(); // <-- 2. Initialize the hook

    // Optional: You can create a handler function, or just put it directly in the onClick
    const handleExploreGames = () => {
        navigate('/games');
    };

    return (
        <div className="testing-page-container">
            {/* Hero Section */}
            <header className="testing-hero">
                <h1>{t('testing-campaign.hero-title')}</h1>
                <p className="hero-subtitle">
                    <Trans i18nKey="testing-campaign.hero-subtitle">
                        Play all our games for absolutely <strong>FREE</strong> while we polish them up. 
                        Your feedback shapes the future of our platform.
                    </Trans>
                </p>
            </header>

            {/* Information Cards */}
            <div className="info-grid">
                <div className="info-card">
                    <h3>{t('testing-campaign.how-it-works-title')}</h3>
                    <p>{t('testing-campaign.how-it-works-desc')}</p>
                </div>
                
                <div className="info-card">
                    <h3>{t('testing-campaign.found-bug-title')}</h3>
                    <p>{t('testing-campaign.found-bug-desc')}</p>
                </div>
            </div>

            {/* Call to Action */}
            <div className="testing-cta">
                {/* 3. Add the onClick event to trigger navigation */}
                <button className="start-playing-btn" onClick={handleExploreGames}>
                    {t('testing-campaign.cta-button')}
                </button>
            </div>
        </div>
    );
};

export default TestingCompaing;